import React from 'react';
import { FaBars } from 'react-icons/fa';
import './MobileMenuToggle.css';

const MobileMenuToggle = ({ onClick, isOpen }) => {
  return (
    <button 
      className={`mobile-menu-toggle${isOpen ? ' open' : ''}`} 
      onClick={onClick}
      aria-label="Toggle mobile menu"
    >
      <FaBars />
    </button>
  );
};

export default MobileMenuToggle; 